import {
  canCheckInAppointment,
  canStartAppointmentInChair,
  checkInStatusLabel,
  defaultChairIdForAppointment,
  formatArrivalTime,
} from '@/lib/calendar/checkIn'
import { canTriggerStylistReady, stylistReadyLabel } from '@/lib/calendar/stylistReady'

/**
 * Pick the best appointment to show on POS for the active ticket.
 * @param {import('@/types/api').Appointment[]} appointments
 * @param {number | null | undefined} customerId
 * @param {number | null | undefined} saleId
 */
export function pickPosFloorAppointment(appointments, customerId, saleId) {
  if (!customerId || !appointments.length) {
    return null
  }

  const forCustomer = appointments.filter(
    (item) =>
      item.customer_id === customerId
      && (canCheckInAppointment(item) || canStartAppointmentInChair(item)),
  )

  if (!forCustomer.length) {
    return null
  }

  const linked = saleId
    ? forCustomer.find((item) => item.sale_id === saleId)
    : null

  return linked ?? forCustomer[0]
}

/**
 * @param {import('@/types/api').ChairBoardPayload | null} board
 * @param {string} guestName
 */
export function findChairRoomForGuest(board, guestName) {
  if (!board?.rooms?.length || !guestName) {
    return null
  }

  const needle = guestName.trim().toLowerCase()

  return (
    board.rooms.find(
      (room) =>
        room.session_id
        && room.guest
        && room.guest.trim().toLowerCase() === needle,
    ) ?? null
  )
}

/**
 * @param {import('@/types/api').ChairBoardPayload | null} board
 */
export function availableChairRooms(board) {
  return (board?.rooms ?? []).filter((room) => room.status === 'available')
}

export {
  canCheckInAppointment,
  canStartAppointmentInChair,
  checkInStatusLabel,
  defaultChairIdForAppointment,
  formatArrivalTime,
  canTriggerStylistReady,
  stylistReadyLabel,
}
